var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('div',[_c('p',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.getTooltip),expression:"getTooltip"}],domProps:{"innerHTML":_vm._s(_vm.getContentParameterization)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }